import { FormField } from '../../lib/interfaces/Form';

export const SUBMIT_BTN_TYPE = {
	FULL: 'full',
	INHERIT: 'inherit',
};

export const INPUT_TYPES = {
	EMAIL: 'email',
	PASSWORD: 'password',
	TEXT: 'text',
	LINK: 'link',
};

export enum RefType {
	VIDEO_REF = 'videoRef',
	CODE_TASK_REF = 'codeTaskRef',
	QUIZ_REF = 'quizRef',
	API_CONTROL = 'apiControlRef',
}

// eslint-disable-next-line import/prefer-default-export
export const FIELD_TYPES = {
	TEXT: 'text',
	MULTISELECT: 'multiselect',
	RICH_EDITOR: 'richEditor',
	RICH_INLINE_EDITOR: 'richInlineEditor',
	FILE: 'file',
	CHECKBOX: 'checkbox',
	CODE_EDITOR: 'codeEditor',
	CODE_TASK_REF: RefType.CODE_TASK_REF,
	QUIZ_REF: RefType.QUIZ_REF,
	QUIZ: 'quiz',
	QUIZ_EDITOR: 'quizEditor',
	HINT: 'hint',
	SELECT: 'select',
	TEXTAREA: 'textarea',
	VIDEO_REF: RefType.VIDEO_REF,
	OVERVIEW_BLOCK: 'overviewBlock',
	CONCLUSION_BLOCK: 'conclusionBlock',
	CODESANDBOX_EMBED: 'codesandbox_embed',
	CODE_BLOCK: 'codeBlock',
	CODE_SAND_PACK: 'sandPack',
	SAND_PACK_WITH_TEXT: 'sandPackWithText',
	AUTOMATED_OVERVIEW: 'automatedOverview',
	API_CONTROL: RefType.API_CONTROL,
	SECRET_CONTENT: 'secretContent',
};

export const OPTION_TYPES = {
	CATEGORIES: 'category',
	TAGS: 'tags',
	OCCUPATIONS: 'occupation',
};

export const supportedLaguages: string[] = ['en', 'ru'];

export const commentFields: FormField[] = [
	{
		name: 'comment',
		init: '',
		label: 'comment',
		placeholder: 'writeComment',
		required: true,
		type: FIELD_TYPES.RICH_INLINE_EDITOR,
	},
	{
		name: 'link',
		init: '',
		label: 'addLink',
		inputType: INPUT_TYPES.LINK,
		required: false,
		type: FIELD_TYPES.TEXT,
		showOnAdditionalBtnClicked: true,
	},
];

export const loginFields: FormField[] = [
	{
		name: 'email',
		init: '',
		label: 'yourEmail',
		inputType: INPUT_TYPES.EMAIL,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
	{
		name: 'password',
		init: '',
		label: 'password',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 6,
			maxLength: 40,
			password: {
				hasLowerCase: true,
				hasNumbers: true,
				hasNonalphas: true,
				hasUpperCase: true,
				allowNonLatin: false,
			},
		},
	},
];

export const registrationFields: FormField[] = [
	{
		name: 'firstName',
		init: '',
		label: 'firstName',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 2,
			maxLength: 40,
			forbidSpecialCharactersForName: true,
		},
	},
	{
		name: 'lastName',
		init: '',
		label: 'lastName',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 2,
			maxLength: 40,
			forbidSpecialCharactersForName: true,
		},
	},
	{
		name: 'email',
		init: '',
		label: 'yourEmail',
		inputType: INPUT_TYPES.EMAIL,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
	{
		name: 'password',
		init: '',
		label: 'password',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 6,
			maxLength: 40,
			password: {
				hasLowerCase: true,
				hasNumbers: true,
				hasNonalphas: true,
				hasUpperCase: true,
				allowNonLatin: false,
			},
		},
	},
	{
		name: 'passwordConfirmation',
		init: '',
		label: 'confirmPassword',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			shouldMatch: {
				field: 'password',
			},
		},
	},
];

export const forgotPasswordFields: FormField[] = [
	{
		name: 'email',
		init: '',
		label: 'yourEmail',
		inputType: INPUT_TYPES.EMAIL,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
];

export const recoveryPasswordFields: FormField[] = [
	{
		name: 'password',
		init: '',
		label: 'password',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 6,
			maxLength: 40,
			password: {
				hasLowerCase: true,
				hasNumbers: true,
				hasNonalphas: true,
				hasUpperCase: true,
				allowNonLatin: false,
			},
		},
	},
	{
		name: 'passwordConfirmation',
		init: '',
		label: 'confirmPassword',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			shouldMatch: {
				field: 'password',
			},
		},
	},
];

export const userProfileFields: FormField[] = [
	{
		name: 'firstName',
		init: '',
		label: 'firstName',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
			forbidSpecialCharacters: true,
		},
	},
	{
		name: 'lastName',
		init: '',
		label: 'lastName',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
			forbidSpecialCharacters: true,
		},
	},
	{
		name: 'email',
		init: '',
		label: 'yourEmail',
		inputType: INPUT_TYPES.EMAIL,
		required: true,
		disabled: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
];

export const contentMandatoryFields = {
	NAME: 'name',
	CONTENT: 'content',
};

export const changePasswordFields: FormField[] = [
	{
		name: 'oldPassword',
		init: '',
		label: 'oldPassword',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 6,
			maxLength: 40,
			password: {
				hasLowerCase: true,
				hasNumbers: true,
				hasNonalphas: true,
				hasUpperCase: true,
				allowNonLatin: false,
			},
		},
	},
	{
		name: 'newPassword',
		init: '',
		label: 'newPassword',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			minLength: 6,
			maxLength: 40,
			password: {
				hasLowerCase: true,
				hasNumbers: true,
				hasNonalphas: true,
				hasUpperCase: true,
				allowNonLatin: false,
			},
		},
	},
	{
		name: 'newPasswordConfirmation',
		init: '',
		label: 'confirmPassword',
		inputType: INPUT_TYPES.PASSWORD,
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			shouldMatch: {
				field: 'newPassword',
			},
		},
	},
];

export const contactUsFields: FormField[] = [
	{
		name: 'contactName',
		init: '',
		label: 'name',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
	{
		name: 'contactEmail',
		init: '',
		label: 'yourEmail',
		inputType: INPUT_TYPES.EMAIL,
		required: true,
		disabled: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 40,
		},
	},
	{
		name: 'subject',
		init: 'general',
		label: 'subject',
		required: true,
		type: FIELD_TYPES.SELECT,
		options: [
			{
				label: 'general',
				value: 'general',
			},
			{
				label: 'support',
				value: 'support',
			},
			{
				label: 'sales',
				value: 'sales',
			},
		],
	},
	{
		name: 'message',
		init: '',
		label: 'yourMessage',
		required: true,
		type: FIELD_TYPES.TEXTAREA,
		validation: {
			minLength: 5,
		},
	},
];
